import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categorySelect", "subcategorySelect"]
  static values = {
    productId: String
  }

  connect() {
   if (this.hasCategorySelectTarget) {
    this.loadSubcategories()
   }
  }

  updateForm(e) {
    switch(e.target.value) {
      case "true":
        this.hiddenNotAdditionalProductFields();
        this.showAdditionalProductFields();
        break;
      case "false":
        this.unhiddenNotAdditionalProductFields();
        this.hideAdditionalProductFields();
        break;
      default:
        this.hiddenNotAdditionalProductFields();
        this.hideAdditionalProductFields();
        break;
    }
  }

  unhiddenNotAdditionalProductFields() {
    const elements = document.querySelectorAll(`.non-additional-product-field`)

    elements.forEach((element) => {
      element.classList.remove("hidden")
    })
  }

  hiddenNotAdditionalProductFields() {
    const elements = document.querySelectorAll(`.non-additional-product-field`)

    elements.forEach((element) => {
      element.classList.add("hidden")
    })
  }

  showAdditionalProductFields() {
    const elements = document.querySelectorAll(`.additional-product-field`)

    elements.forEach((element) => {
      element.classList.remove("hidden")
    })
  }

  hideAdditionalProductFields() {
    const elements = document.querySelectorAll(`.additional-product-field`)

    elements.forEach((element) => {
      element.classList.add("hidden")
    })
  }

  removeNotAdditionalProductFields() {
    const elements = document.querySelectorAll(`.non-additional-product-field`)
    elements.forEach((element) => {
      element.remove();
    });
  }

  loadSubcategories() {
    const categoryId = this.categorySelectTarget.value

    if (!categoryId) {
      Turbo.visit('/admin/product_categories/empty/subcategories', { frame: "subcategories_frame" })
      return
    }

    Turbo.visit(`/admin/product_categories/${categoryId}/subcategories${this.hasSubcategorySelectTarget 
      && this.subcategorySelectTarget.value ? "?subcategory_id=" + this.subcategorySelectTarget.value : ""}`, {
      frame: "subcategories_frame"
    })
  }

  prepareFormData() {
    const additional = document.querySelector('[name=product[additional]]')
    if(additional) {
      switch(additional.value) {
        case "true":
          this.removeNotAdditionalProductFields()
          break
      }
    }
  }
}